export const getMapOptions = (isModalOpen: boolean, isSmall: boolean) => {
  const winAvailable = typeof window !== 'undefined';

  const streetViewPosition = winAvailable && isSmall ? 'RIGHT_TOP' : 'LEFT_TOP';
  const mapTypeControlPosition =
    winAvailable && isSmall ? 'TOP_RIGHT' : 'TOP_LEFT';
  const cameraControlPosition =
    winAvailable && isSmall ? 'INLINE_END_BLOCK_CENTER' : 'LEFT_BOTTOM';

  const mapOptions = {
    fullscreenControl: false,
    zoomControl: false,
    mapTypeControl: isModalOpen,
    streetViewControl: isModalOpen,
    streetViewControlOptions: {
      position: window.google?.maps?.ControlPosition?.[streetViewPosition]
    },
    mapTypeControlOptions: {
      style:
        winAvailable &&
        window.google?.maps?.MapTypeControlStyle?.HORIZONTAL_BAR,
      position: window.google?.maps?.ControlPosition?.[mapTypeControlPosition]
    },
    cameraControlOptions: {
      position: window.google?.maps?.ControlPosition?.[cameraControlPosition]
    }
  };

  const mapStyle = {
    width: '100%',
    height: isModalOpen ? '100%' : '165px'
  };

  return {
    mapStyle,
    mapOptions
  };
};
